

export type ClientConnectCustomFieldSet = {
    fieldSetName: string;
    fields: CustomFields[];
}

export type CustomFields = {
    name: string;
    type: string;
    perClient: boolean;
    value: string;
    fromSet: boolean;
    id: string;
}


export const defaultFieldSet: ClientConnectCustomFieldSet = {
    fieldSetName: '',
    fields: [
        {
            name: '',
            type: 'text',
            perClient: false,
            value: '',
            fromSet: false,
            id: '-1'
        }
    ],
}